import { render } from "./warehouses.vue?vue&type=template&id=63a1cc8a"
import script from "./warehouses.vue?vue&type=script&lang=js"
export * from "./warehouses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__